import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  icon: 'https://cdn.magicpatterns.com/uploads/7woRHUauhRrvPAtp5ssTYa/Portada_Tomo_1_MockUp.png',
  title: 'Tomo 1 — El Módulo Semilla',
  subtitle: 'Tu Primera Casa: 35m² que Cambian Todo',
  desc: 'Planta completa: estar-comedor, dormitorio, baño y cocina-lavadero. Construí en etapas sin demoler.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/dAdFPt2emB2L2Ehwqby2kt/Portada_Tomo_2_MockUp.png',
  title: 'Tomo 2 — La Primera Expansión',
  subtitle: 'De 35m² a 55m²: Tu Segundo Dormitorio Sin Demoler Nada',
  desc: 'Ampliá el Módulo Semilla con un segundo dormitorio sin interrumpir tu vida diaria.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/2hiFPhyiNszkXL4kQyjgsT/Portada_Tomo_3_MockUp.png',
  title: 'Tomo 3 — La Vivienda Familiar',
  subtitle: '72m²: El Segundo Baño que Cambia la Vida Familiar',
  desc: 'Dos baños, cocina independiente y lavadero. Espacio real para una familia de cuatro.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/i5Pr9PGAxKzkzsUyJx8ak3/Portada_Tomo_4_MockUp.png',
  title: 'Tomo 4 — La Vivienda Premium',
  subtitle: '95m²: Suite Matrimonial, 3 Dormitorios y Terminaciones de Valor',
  desc: 'Suite con vestidor, tres dormitorios y terminaciones que aumentan el valor del inmueble.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/ujQP7xnR8mrEdR9XVvsaX5/Portada_Tomo_5_MockUp.png',
  title: 'Tomo 5 — El Kit del Corralón',
  subtitle: 'Cómputo y Presupuesto Exacto para Tu Obra',
  desc: 'Calculá cuánto material necesitás antes de ir al corralón. Sin presupuestos inflados.'
}, {
  icon: 'https://cdn.magicpatterns.com/uploads/2jHRxWVU7VJusvep4KCDsf/Portada_Tomo_6_MockUp.png',
  title: 'Tomo 6 — El Manual de Obra',
  subtitle: 'Supervisá Tu Construcción Sin Ser Experto',
  desc: 'Controlá el avance, verificá la calidad y evitá que te cobren de más.'
}];
const includes = ['Distribución completa con medidas reales', 'Lista de materiales lista para el corralón', 'Presupuesto orientativo actualizado', 'Orden de construcción por etapa', 'Errores más comunes y cómo evitarlos', 'Decisiones de diseño explicadas en lenguaje de propietario', 'Conexión con los tomos anteriores y siguientes', '100% adaptado al mercado argentino actual'];
export function ProductOverview() {
  return <section id="sistema" className="py-20 bg-beige" data-id="element-303">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-304">
        <div className="text-center mb-16" data-id="element-305">
          <div className="inline-flex items-center justify-center gap-2 mb-4" data-id="element-306">
            <span className="text-2xl" data-id="element-307">🏆</span>
            <h2 className="text-sm font-bold tracking-widest text-gold uppercase" data-id="element-308">
              ZENTRAL PRO™ — PACK CI 6×6
            </h2>
          </div>
          <h3 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-309">
            6 Tomos + 4 Bonos — 35m² → 95m²
          </h3>
          <p className="text-xl text-gray-600" data-id="element-310">
            Construí con claridad desde el día uno y evitá decisiones que salen
            caras.
          </p>
        </div>

        {/* Journey Map / Pills */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-16" data-id="element-311">
          {['T1 35m²', 'T2 55m²', 'T3 72m²', 'T4 95m²', 'T5 Corralón', 'T6 Obra'].map((pill, i) => <div key={i} className="bg-white border border-beige-dark px-4 py-2 rounded-full text-sm font-semibold text-charcoal shadow-sm flex items-center gap-2" data-id="element-312">
              <span className="w-2 h-2 rounded-full bg-gold" data-id="element-313"></span>
              {pill}
            </div>)}
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-beige-dark overflow-hidden" data-id="element-314">
          <div className="relative overflow-hidden" style={{
          height: '200px'
        }} data-id="element-315">
            <img src="https://cdn.magicpatterns.com/uploads/aaKJHB8nbv8nhL4HyqGadV/image.png" alt="Colección Arquitectura Argentina - Volumen Completo" className="w-full h-full object-cover object-center" data-id="element-316" />
          </div>

          <div className="p-8 md:p-12" data-id="element-317">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10" data-id="element-318">
              {tomos.map((tomo, i) => <div key={i} className="flex gap-4" data-id="element-319">
                  <div className="shrink-0 flex items-start" data-id="element-320">
                    {tomo.icon.startsWith('http') ? <img src={tomo.icon} alt={tomo.title} className="w-32 object-contain rounded-md shadow-md" data-id="element-321" /> : <span className="text-4xl" data-id="element-322">{tomo.icon}</span>}
                  </div>
                  <div data-id="element-323">
                    <h5 className="font-bold text-lg text-charcoal mb-1" data-id="element-324">
                      {tomo.title}
                    </h5>
                    <p className="text-gold font-medium text-sm mb-2" data-id="element-325">
                      {tomo.subtitle}
                    </p>
                    <p className="text-gray-600 text-sm leading-relaxed" data-id="element-326">
                      {tomo.desc}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="mt-16 pt-12 border-t border-beige-dark" data-id="element-327">
              <h5 className="font-serif font-bold text-xl mb-6 text-center" data-id="element-328">
                Cada tomo incluye:
              </h5>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-329">
                {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-330">
                    <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0 mt-0.5" data-id="element-331" />
                    <span className="text-sm text-gray-700 font-medium" data-id="element-332">
                      {item}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}